export const state = () => ({
  visible: false,
  callback: null,
});

export const mutations = {
  SHOW_MODAL(state, callback = null) {
    state.visible = true;
    state.callback = callback;
  },
  HIDE_MODAL(state) {
    state.visible = false;
    state.callback = null;
  },
};

export const actions = {
  showModal({ commit }, callback) {
    commit('SHOW_MODAL', callback);
  },
  hideModal({ commit }) {
    commit('HIDE_MODAL');
  },
  executeCallback({ state, dispatch }) {
    if (typeof state.callback === 'function') {
      state.callback();
    }
    dispatch('hideModal');
  },
};
